import { useState } from "react";
import styled from "styled-components";
import { DotsThreeOutlineVertical } from "phosphor-react";

export const inputWithHelpers = (Component) => (props) => {
  const [showHelpers, setShowHelpers] = useState(false);
  return (
    <Container>
      <Component {...props} />
      <HelpersContainer>
        <HelpersStyle showHelpers={showHelpers} helpers={props?.helpers}>
          {props?.helpers?.map((control, index) => (
            <HelperStyle key={index}>{control}</HelperStyle>
          ))}
        </HelpersStyle>
        {props?.helpers?.length > 1 && (
          <HelpersToggle onClick={() => setShowHelpers((prev) => !prev)}>
            <DotsThreeOutlineVertical
              size={12}
              weight="thin"
              style={{ verticalAlign: "middle" }}
            />
          </HelpersToggle>
        )}
      </HelpersContainer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const HelpersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  overflow-x: hidden;
  height: 100%;
  z-index: 10;
`;

const HelpersStyle = styled.span`
  display: flex;
  position: relative;
  align-items: center;
  padding-left: 5px;
  opacity: ${(props) =>
    props?.helpers?.length > 1 ? (props?.showHelpers ? 1 : 0) : 1};
  right: ${(props) =>
    props?.helpers?.length > 1 ? (props?.showHelpers ? 0 : "-100px") : 0};
  transition: 100ms ease-in-out;
  z-index: 10;
`;

const HelperStyle = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const HelpersToggle = styled.button`
  border: none;
  background-color: #fff;
  z-index: 10;
  cursor: pointer;
  padding-right: 5px;
`;
